{
    "name": "@redstone-finance/evm-connector",
    "version": "0.0.18",
    "description": "A tool to inject RedStone data into EVM compatible smart contracts",
    "main": "dist/src/index.js",
    "license": "MIT",
    "scripts": {
        "test": "hardhat test",
        "build": "rm -rf dist && tsc -build",
        "benchmark": "hardhat test benchmarks/run-benchmarks.ts",
        "compile": "hardhat compile",
        "postversion": "yarn build && git commit -a -m \"build: $npm_package_name@$npm_package_version\" && git push"
    },
    "dependencies": {
        "@openzeppelin/contracts": "^4.7.3",
        "axios": "^1.1.3",
        "ethers": "^5.6.8",
        "redstone-protocol": "1.0.5",
        "redstone-sdk": "1.0.7"
    },
    "devDependencies": {
        "@ethersproject/abi": "^5.6.3",
        "@ethersproject/bytes": "^5.6.1",
        "@ethersproject/providers": "^5.6.8",
        "@nomiclabs/hardhat-ethers": "^2.0.6",
        "@nomiclabs/hardhat-waffle": "^2.0.3",
        "@openzeppelin/contracts-upgradeable": "^4.6.0",
        "@typechain/ethers-v5": "^10.0.0",
        "@typechain/hardhat": "^6.0.0",
        "@types/chai": "^4.3.1",
        "@types/chai-as-promised": "^7.1.5",
        "@types/mocha": "^9.1.1",
        "@types/node": "^17.0.37",
        "chai": "^4.3.6",
        "chai-as-promised": "^7.1.1",
        "ethereum-waffle": "^3.4.4",
        "hardhat": "^2.9.7",
        "hardhat-gas-reporter": "^1.0.8",
        "msw": "^0.47.4",
        "prettier-plugin-solidity": "^1.0.0-beta.19",
        "ts-node": "^10.8.0",
        "typechain": "^8.0.0"
    },
    "files": [
        "dist/**/*",
        "contracts/**/*"
    ]
}
